require('core-js/modules/es.object.from-entries')
require('core-js/modules/es.promise.finally')
require('core-js/modules/esnext.math.clamp')
require('core-js/modules/esnext.string.replace-all')
require(`./${process.env.REACT_APP_WEBSITE}`)

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Math {
  clamp: (value: number, min: number, max: number) => number
}
